<template>
	<div>
		<choices
				:instantSelection="instantSelection"
				:selectable="isSinglePlayer"
				class="choices"
				v-bind:choices="choices"
				v-on:value="onValue"
		/>

		<div class="counter-container" v-if="!isSinglePlayer">
			<counter :current="studentAnswerCount" :total="studentCount" class="counter">
				{{$t('game.answers')}}
			</counter>
		</div>
	</div>
</template>
<script>
	import PageComponentTemplate from '../page-component-template'
	import Counter from '@/components/counter'
	import Choices from '@/components/choices'
	import {mapGetters} from 'vuex'
	import GameType from '@/enum/GameType'

	export default {
		name: 'page-component-full-choices',
		extends: PageComponentTemplate,
		components: {
			Counter,
			Choices
		},
		computed: {
			...mapGetters({
				gameType: 'getGameType'
			}),
			isSinglePlayer() {
				return this.gameType === GameType.SinglePlayer;
			},
			choices() {
				if (this.options && this.options.hasOwnProperty('choices')) {
					return this.options.choices
				}

				return []
			},
			roomState() {
				if (this.$gameClient && this.$gameClient.room && this.$gameClient.room.state) {
					return this.$gameClient.room.state
				}

				return null
			},
			studentCount() {
				return this.roomState ? this.roomState.studentCount : 0
			},
			voteCounts() {
				return this.roomState ? this.roomState.voteCounts : [0, 0, 0, 0, 0, 0]
			},
			studentAnswerCount() {
				// Add up all the votes to get the total count
				return this.voteCounts.reduce((a, b) => a + b, 0)
			},
			instantSelection() {
				return this.isSinglePlayer;
			}
		},
		methods: {
			onValue(val) {
				if (this.instantSelection) {
					this.$emit('pickChoice', this.choices[val])
				}
			}
		}
	}
</script>
<style lang="less" scoped>
	.counter-container {
		width: fit-content;
		margin: 20px auto;
		margin-bottom: 30px;
	}
</style>